<template>
  <div
    class="promotionBanner"
    :class="{ promotionBannerStateMobile: isMobile }"
  >
    <swiper
      v-if="promotionList.length"
      :options="swiperOption"
      ref="promotionBannerSwiper"
    >
      <swiper-slide v-for="(el, idx) in promotionList" :key="idx">
        <a href="" @click.prevent="handleClick(el.linkUrl, el.promotionId)">
          <span
            class="imageBg"
            :style="{ backgroundImage: 'url(' + el.imageUrl + ')' }"
          >
            <span class="accessibilityHide">{{ el.promotionName }}</span>
          </span>
        </a>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { mapGetters } from 'vuex'
import { beforeSendLog, isMobile } from '@/utils'

export default {
  name: 'PromotionBanner',
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      isMobile,
      swiperOption: {
        slidesPerView: 'auto',
        autoplay: {
          delay: 3000
        },
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  methods: {
    handleClick(linkUrl, promotionId) {
      beforeSendLog('Banner', { BannerID: promotionId })
      if (linkUrl) {
        location.href = linkUrl
      }
    }
  },
  computed: {
    ...mapGetters('main', ['promotionList'])
  }
}
</script>

<style lang="scss">
.promotionBanner {
  position: relative;
  max-width: 1024px;
  margin: 0 auto;
  background-color: #fff;
  a {
    display: block;
  }
  .imageBg {
    display: block;
    max-height: 265px;
    height: 265px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto 100%;
  }
  .swiper-pagination-bullets {
    bottom: 3px;
  }
  .swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 0 0 4px;
  }
  .swiper-pagination-bullet {
    width: 7px;
    height: 7px;
    background-color: transparent;
    border: 1px solid #fcfcfc;
    opacity: 1;
  }
  .swiper-pagination-bullet-active {
    width: 8px;
    height: 8px;
    border: 1px solid #5a5fe3;
    background-color: #5a5fe3;
  }
  .swiper-button-prev,
  .swiper-button-next {
    top: 50%;
    width: 41px;
    height: 43px;
    margin-top: -22px;
    background: url(../../assets/images/set_icon.png) no-repeat 0 -1000px;
    background-size: 100px;
    opacity: 0.6;
    &:hover {
      opacity: 1;
    }
  }
  .swiper-button-prev {
    left: 0;
  }
  .swiper-button-next {
    right: 0;
    background-position: -50px -1000px;
  }
  .swiper-button-disabled {
    display: none;
  }
}
.promotionBannerStateMobile {
  .swiper-button-prev,
  .swiper-button-next {
    display: none;
  }
}
@media all and (max-width: 710px) {
  .promotionBanner {
    .imageBg {
      height: 52vw;
    }
  }
}
</style>
